import {prop, range} from 'ramda';

import {PositionedDashboardGridTile} from './allocateDashboardGrid';
import {DASHBOARD_TILE_SIZES} from './dashboardTileSizes';

// Lifts every tile by the number of rows no tile covers above it, so a move never leaves a blank
// band on the board. The tiles below an empty row move as one block, so nothing can start to overlap.
export function closeEmptyDashboardRows(
  board: PositionedDashboardGridTile[]
): PositionedDashboardGridTile[] {
  const coveredRows = new Set(
    board.flatMap((tile) => range(tile.row, tile.row + prop(tile.size, DASHBOARD_TILE_SIZES).rows))
  );
  const bottom = Math.max(0, ...coveredRows) + 1;
  const emptyRows = range(0, bottom).filter((row) => !coveredRows.has(row));

  if (emptyRows.length === 0) {
    return board;
  }

  return board.map((tile) => ({
    ...tile,
    row: tile.row - emptyRows.filter((row) => row < tile.row).length,
  }));
}
